import moment from "moment";
import { DATE_FORMAT, BUILD_PATH } from "../constants/app.constants";
import { URL } from "../constants/app.constants";

type ParamBody = {
  [key: string]: string | number | Date | null | boolean | undefined;
};

type FileBody = {
  [key: string]: File | null | undefined;
};

export const getCookieValue = (cookieNames: string | string[]) => {
  if (typeof document === "undefined" || !document.cookie) {
    return "";
  }

  const names = Array.isArray(cookieNames) ? cookieNames : [cookieNames];
  const cookieMap = document.cookie.split(";").reduce<Record<string, string>>(
    (cookies, cookie) => {
      const [rawName, ...rawValue] = cookie.split("=");
      const name = rawName.trim();

      if (name) {
        cookies[name] = decodeURIComponent(rawValue.join("=").trim());
      }

      return cookies;
    },
    {}
  );

  for (const name of names) {
    if (cookieMap[name]) {
      return cookieMap[name];
    }
  }

  return "";
};

export const getStoredValueWithCookieFallback = (
  storageKey: string,
  cookieNames: string | string[] = storageKey
) => window.localStorage.getItem(storageKey) || getCookieValue(cookieNames);

export const isLoggedIn = () => {
  if (
    localStorage.getItem("username") &&
    localStorage.getItem("empId") &&
    localStorage.getItem("uname")
  ) {
    return {
      signedIn: true,
    };
  } else
    return {
      signedIn: false,
    };
};

export const callApi = async (
  command: string,
  params: ParamBody,
  type: string,
  files?: FileBody
) => {
  const formData = new FormData();
  formData.append("command", command);
  formData.append("params", JSON.stringify(params));
  formData.append("type", type);

  if (files) {
    Object.entries(files).forEach(([key, file]) => {
      if (file) {
        formData.append(key, file);
      }
    });
  }

  const token = localStorage.getItem("authToken");

  const response = await fetch(`${URL}`, {
    method: "POST",
    body: formData,
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
     credentials: "include"
  });

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  return response.json();
};
